import { useCallback, useRef } from 'react';

const useThrottle = <T extends (...args: any[]) => void>(
  callback: T,
  delay: number
) => {
  const lastRan = useRef(0);

  return useCallback(
    (...args: Parameters<T>) => {
      const now = Date.now();
      if (now - lastRan.current >= delay) {
        callback(...args);
        lastRan.current = now;
      }
    },
    [callback, delay]
  );
};

export default useThrottle;
